import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState = {
  colorKey: "none",
  selections: {},
};

export const filtersSlice = createSlice({
  name: "filters",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    updateColorKey: (state, { payload: { name } }) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      return {
        ...state,
        colorKey: name,
      };
    },
    addFilter: (state, { payload: { key, filter } }) => {
      return {
        ...state,
        selections: {
          ...state.selections,
          [key]: filter,
        },
      };
    },
  },
});

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectColorKey = (state) => state.filters.colorKey;

export const selectFilterSelections = (state) => state.filters.selections;



export const { updateColorKey, addFilter } = filtersSlice.actions;

export default filtersSlice.reducer;
